export default {
    schedule_workOrder_customer: "Cliente",
    schedule_workOrder_phone: "Teléfono",
    schedule_workOrder_email: "Correo electrónico",
    schedule_workOrder_type: "tipo",
    schedule_workOrder_description: "Descripción",
    schedule_workOrder_customer: "Clientes",
    schedule_workOrder_workOrderNumber: "Número de orden",
    schedule_workOrder_conflict: "No se puede asignar más de una orden de trabajo en la misma fecha.",
    schedule_workOrder_title_conflict: "Conflicto",
    schedule_workOrder_conflict_event: "No se puede asignar más de una orden de trabajo en la misma fecha.",
    schedule_workOrder_title_conflict_event: "Conflicto",
    schedule_workOrder_move_message_error: "La fecha de la orden de trabajo no puede ser menor a la fecha actual o el conductor el asignado",
    schedule_workOrder_move_title_error: "Orden de trabajo no movida",
    schedule_workOrder_address: "Dirección",
    workOrder_tab_advancedFilters_tags: "Etiquetas",
    schedule_workOrder_drivers: "Conductores",
    schedule_workOrder_view_day: "Día",
    schedule_workOrder_view_week: "Semana",
    schedule_workOrder_view_month: "Mes",
    filters: "Filtros",
    add: "Agregar",
    schedule_workOrder_search_events: "Buscar ordenes de trabajo por número de orden, cliente, tipo, estado, conductor, descripción, nombre de contacto, o dirección"
}